import { FilterOperation } from "data/@types/GlobalSearchData";
import { FilterOperator } from "ui/partials/global-search/filters/OperatorSelect";

export const operatorToOperation = (op: FilterOperator): FilterOperation => {
  switch (op) {
    case "contains":
      return "CONTAINS";
    case "does_not_contain":
      return "NOT_CONTAINS";
    case "equals":
      return "EQUALS";
    case "does_not_equal":
      return "NOT_EQUALS";
    case "starts_with":
      return "STARTS_WITH";
    case "ends_with":
      return "ENDS_WITH";
    default:
      return "CONTAINS";
  }
};
